import React, { Component } from 'react'
import { MenuRouteGroupName } from '../routes/menuRoutes'
import menuRouteUtil from '../utils/menuRoute.util'
import CollapsibleMenu from './CollapsibleMenu/CollapsibleMenu'
import SubMenuItem from './SubMenuItem'

interface SubMenuProps {
    type: MenuRouteGroupName
    permittedModules: string[]
    onRoute: () => void
}

export default class SubMenu extends Component<SubMenuProps> {
  get subsidiaries () {
    const { type, permittedModules } = this.props
    return menuRouteUtil.collectPermittedSubsidiaries(type, permittedModules)
  }

  get items () {
    return this.subsidiaries &&
            this.subsidiaries.map(item => {
              if ('to' in item) {
                return (
                        <SubMenuItem
                            text={item.text}
                            icon={item.icon}
                            to={item.to}
                            onRoute={this.props.onRoute}
                            key={item.to}
                        />
                )
              }

              if ('subsidiaries' in item) {
                return (
                        <CollapsibleMenu
                            collapsible={item}
                            onRoute={this.props.onRoute}
                            key={item.text}
                        />
                )
              }

              return null
            })
  }

  render () {
    return (
            <div className="pt-5">
                {this.items}
            </div>
    )
  }
}
